<template>
  <div>

    <el-row>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item label="当前月份">
          <el-date-picker v-model="formInline.payDate" type="month" placeholder="选择当前月份">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-checkbox v-model="radio" @change="changeRadioAction" >{{checkBoxMsg}}</el-checkbox>
        </el-form-item>
        <el-form-item label="统计类型" v-if="this.currentCusId === '9999008199'">
          <el-select class="query-select" v-model="formInline.queryType" multiple collapse-tags :placeholder="$t('selectSummaryStaff')" filterable clearable>
  <!--          <el-option v-for="item in dictData.emp" :key="item.id" :value="item.idCard" :label="item.empName" />-->
            <el-option label="上季度绩效考核结果" value="E204065" key="E204065"></el-option>
            <el-option label="员工状态" value="E204063" key="E204063"></el-option>
            <el-option label="户口性质" value="E204067" key="E204067"></el-option>
            <el-option label="所属部分" value="E204062" key="E204062"></el-option>
            <el-option label="社保缴纳城市" value="E204066" key="E204066"></el-option>
            <el-option label="职层" value="E204064" key="E204064"></el-option>
            <el-option label="部门" value="E204060" key="E204060"></el-option>
            <el-option label="成本中心" value="COST_CENTER" key="COST_CENTER"></el-option>
            <el-option label="发薪时间" value="E204121" key="E204121"></el-option>
            <el-option label="报税组合" value="TAX_GROUP_NAME" key="TAX_GROUP_NAME"></el-option>
            <el-option label="社保缴存额项" value="E204141" key="E204141"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计类型" v-else>
          <el-select v-model="formInline.queryType" style="width:120px"  placeholder="请选择">
            <el-option label="成本中心" value="COST_CENTER"></el-option>
            <el-option label="分公司" value="ORG_ID"></el-option>
            <el-option label="部门" value="DEPT_ID"></el-option>

          </el-select>
        </el-form-item>

        <el-form-item label="开始时间">
          <el-date-picker v-model="formInline.startDate" style="width:145px"  type="month" value-format="yyyy-MM" placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="formInline.endDate" style="width:145px"  type="month" value-format="yyyy-MM"  placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>

<!--
        <el-form-item label="统计日期类型">
          <el-select v-model="formInline.monthType" placeholder="请选择统计日期类型" style="width: 180px;">
            <el-option label="税金所属月份" value="1"></el-option>
            <el-option label="工资所属月份" value="2"></el-option>
&lt;!&ndash;
            <el-option label="开票所属月份" value="3"></el-option>
&ndash;&gt;
            <el-option label="发放月份" value="4"></el-option>
          </el-select>
        </el-form-item>
-->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toColumnPage">自定义表头</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toExport">导出</el-button>
        </el-form-item>

      </el-form>
    </el-row>
    <div style="height: calc(100vh - 212px);">
      <vxe-grid  id="costCenterSummary"
     resizable
     auto-resize
     border
     show-overflow
     show-footer
     ref="xGrid"
     align="center"
     width="100%"
     height="100%"
     :show-header-overflow="true"
     :loading="loading"
     :columns="tableColumn"
     :custom-config="{storage: true}"
     :footer-method="footerMethod"
     :data.sync="tableData"

      >
        <template v-slot:empty>
                    <span>
                      <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                            <use xlink:href="#icon-kong"></use>
                          </svg>
                      <p class="noData">暂无数据</p>
                    </span>
        </template>
      </vxe-grid>
    </div>
    <vxe-pager
      :loading="loading"
      :current-page="formInline.page"
      :page-size="formInline.limit"
      :total="formInline.total"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="handlePageChange">
    </vxe-pager>

    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="dialogheaderVisible"
    >
      <customHeader :headerList.sync="headerList" v-if="dialogheaderVisible" :headerData.sync="headerData"
      >

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="dialogheaderVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import customHeader from "@/wage-components/ciic-custom-table-header/index.vue";
  import {
    getCostCenterSummaryColumnsList,
    addCostCenterSummary,
    getCostCenterSummaryColumnList
  } from "@/api/report/report.js";
  import {bspTableFilter} from "../../../filters";
  import {mapGetters} from "vuex";
  import XEUtils from 'xe-utils';
  import exportMethod from '@/util/export.js'
  import {deepCopy} from '@/util/util';
  import store from "@/store";
  import {getOrgInfo} from "@/api/org/org";


  export default {
    components: {customHeader},
    created() {
      this._getCostCenterSummaryColumns({});
      this._getCompanyOrg(store.getters.cusId);
      this._getCostCenterSummaryColumnList(this.formInline);
    },
    data() {
      return {
        hiddenColumns:[],//隐藏列信息，备用
        expHiddenColumns:[],//需要隐藏的列
        sumListCode:[],//需要合计的列信息
        dialogheaderVisible: false,
        radio: false,
        checkBoxMsg:'隐藏空列',
        formInline: {
          queryType: 'COST_CENTER',
          startDate: '',
          endDate:'',
          monthType: '2',
          limit: 20,
          page: 1,
          total: 0
        },
        currentCusId: store.getters.cusId ? store.getters.cusId : '',
        headerList:[],
        headerData:[],
        tableColumn:[],
        orgMap:{},//组织结构map
        tableData:[]
      }
    },
    computed:{
      ...mapGetters([
        'dicts',
      ]),
    },
    methods: {
      //重置
      resetAction(){
        this.hidden = false;
        this.$refs.xGrid.resetColumn();
      },
      changeRadioAction(){
        if (this.radio) {
          this.hiddenAction();//隐藏
          //this.checkBoxMsg='重置';
        }else{
          this.resetAction();//重置
          //this.checkBoxMsg='隐藏空列';
        }
      },
      //隐藏
      hiddenAction(){
        this.expHiddenColumns = []; // 清空
        if(this.hiddenColumns && this.hiddenColumns.length>0){
          this.hidden=true;
          // 先收集所有需要隐藏的列对象
          const allCols = [];
          this.tableColumn.forEach(col => {
            // 检查自身field
            if (col.field && !this.hiddenColumns.includes(col.field)) {
              allCols.push(col);
            }
            // 检查分组列
            if (col.grounpColumns && Array.isArray(col.grounpColumns)) {
              const hasChild = col.grounpColumns.some(sub => !this.hiddenColumns.includes(sub.field));
              if (hasChild) {
                allCols.push(col);
              }
            }
          });
          // 去重
          this.expHiddenColumns = [...new Set(allCols)];
          // 然后执行隐藏操作，遍历hiddenColumns
          this.hiddenColumns.forEach(filed => {
            this.$refs.xGrid.hideColumn(this.$refs.xGrid.getColumnByField(filed));
          });
        }
      },
      _getCompanyOrg(cusId){
        getOrgInfo(cusId).then(res=>{
          let orgData = res.data;//查询机构树
          let map = {};
          for (let i = 0,l=orgData.length; i <l; i++) {
            map[orgData[i].id]=orgData[i].orgName;//id:orgName结构存储
          }
          this.orgMap =  map;
        })
      },
      footerMethod ({ columns, data }) {
        this.hiddenColumns = [];
        const result = [
          columns.map((column, columnIndex) => {

            if(data&&data.length>0){
              let columFiled = column.property;
              let result = XEUtils.every(data,(data)=>{
                return data[columFiled] ===0 || data[columFiled]===null
                  || data[columFiled] === '0'|| data[columFiled] === '0.0'|| data[columFiled] === '0.00'
              })
              if(result){
                this.hiddenColumns.push(columFiled)
              }
            }

            if (columnIndex === 1) {
              return '合计'
            }
            if (this.sumListCode.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return null
          })
        ]

        this.$nextTick(() => {
          if (this.radio) {
            this.hiddenAction();
          }
        });
        return result;
      },
      //跳转自定义表头设置
      toColumnPage(){
        console.log(this.headerList);
        this.dialogheaderVisible = true
      },
      saveCusHeader(){
        addCostCenterSummary({entityList:this.headerList}).then(res=>{
          this.dialogheaderVisible = false;
          this._getCostCenterSummaryColumns(this.formInline);
          this._getCostCenterSummaryColumnList(this.formInline);
        })
      },
      onSubmit(){
        if(this.formInline.monthType){
          this._getCostCenterSummaryColumns(this.formInline);
          this._getCostCenterSummaryColumnList(this.formInline);
        }else {
          this.$message.error('请选择统计日期类型');

        }

      },
      handlePageChange({ currentPage, pageSize }){
        this.formInline.page = currentPage;
        this.formInline.limit = pageSize;
        this._getWageComparisonColumnList(this.formInline);
      },
      _getCostCenterSummaryColumnList(obj){
        getCostCenterSummaryColumnList(obj).then(res => {
          this.tableData = res.data.records;
          for (let i=0;i<res.data.records.length;i++){
            let idCardType= bspTableFilter(res.data.records[i].idCardType,{'1':'dict',2:this.dicts})
            this.$set(this.tableData[i],'idCardType',idCardType)
            if(this.formInline.queryType=='ORG_ID'){
              let orgId= bspTableFilter(res.data.records[i].orgId,{'1':'refs','3':this.orgMap})
              this.$set(this.tableData[i],'orgId',orgId)
            }
            if(this.formInline.queryType=='DEPT_ID'){
              let deptId= bspTableFilter(res.data.records[i].deptId,{'1':'refs','3':this.orgMap})
              this.$set(this.tableData[i],'deptId',deptId)
            }
          }
          this.formInline.total = res.data.total;
        })
      },
      _getCostCenterSummaryColumns(obj){
        getCostCenterSummaryColumnsList(obj).then(res => {
/*          const headerList = res.data.itemDatas.length>0?res.data.itemDatas:res.data.sysLists;
          this.$set(this,'headerData',res.data.checkLists);
          this.$set(this,'headerList',headerList);*/
          this.headerData = res.data.checkLists;
          this.headerList = res.data.itemDatas.length>0?res.data.itemDatas:res.data.sysLists;
          this.sumListCode = res.data.sumListCode;
          let records = res.data.itemDatas.length>0?res.data.itemDatas:res.data.sysLists;
          let columns = records.map(column =>{
            column.title = column.itemNameCh;
            column.field = column.field;
            column.minWidth = 100;
            return column
          });

          if (this.currentCusId === '9999008199'){
            if (this.formInline.queryType.includes('E204065')) {
              columns.unshift({title: '上季度绩效考核结果', field: 'E204065', width: 100, fixed: 'left'});
            }

            if (this.formInline.queryType.includes('E204063')) {
              columns.unshift({title: '员工状态', field: 'E204063', width: 100, fixed: 'left'});
            }
            if (this.formInline.queryType.includes('E204067')) {
              columns.unshift({title: '户口性质', field: 'E204067', width: 100, fixed: 'left'});
            }
            if (this.formInline.queryType.includes('E204062')) {
              columns.unshift({title: '所属部分', field: 'E204062', width: 100, fixed: 'left'});
            }

            if (this.formInline.queryType.includes('E204066')) {
              columns.unshift({title: '社保缴纳城市', field: 'E204066', width: 100, fixed: 'left'});
            }
            if (this.formInline.queryType.includes('E204064')) {
              columns.unshift({title: '职层', field: 'E204064', width: 100, fixed: 'left'});
            }

            if (this.formInline.queryType.includes('E204060')) {
              columns.unshift({title: '部门', field: 'E204060', width: 100, fixed: 'left'});
            }
            if (this.formInline.queryType.includes('COST_CENTER')) {
              columns.unshift({title: '成本中心', field: 'COST_CENTER', width: 100, fixed: 'left'});
            }
            if (this.formInline.queryType.includes('E204121')) {
              columns.unshift({title: '发薪时间', field: 'E204121', width: 100, fixed: 'left'});
            }
            if (this.formInline.queryType.includes('TAX_GROUP_NAME')) {
              columns.unshift({title: '报税组合', field: 'TAX_GROUP_NAME', width: 100, fixed: 'left'});
            }

            if (this.formInline.queryType.includes('E204141')) {
              columns.unshift({title: '社保缴存额项', field: 'E204141', width: 100, fixed: 'left'});
            }
          }else {
            if(this.formInline.queryType=='COST_CENTER'){
              columns.unshift({ title:'成本中心', field:'costCenter',width: 100 ,fixed:'left'});
            }
            if(this.formInline.queryType=='ORG_ID'){
              columns.unshift({ title:'分公司', field:'orgId',width: 100,fixed:'left'  });
            }
            if(this.formInline.queryType=='DEPT_ID'){
              columns.unshift({ title:'部门', field:'deptId',width: 100 ,fixed:'left' });
            }
          }

          columns.unshift({ title:'序号',type: 'seq', width: 50,fixed:'left' });
          this.tableColumn = columns;
        })
      },
      toExport(){
        let cols = [];
        if(this.radio && this.expHiddenColumns && this.expHiddenColumns.length > 0){
          cols=this.$clone(this.expHiddenColumns);
        } else {
          cols=this.$clone(this.tableColumn);
        }
        let column = deepCopy(cols);
        column.splice(0,1);
        exportMethod(
        {
          columns: column,
          type: "excel",
          beanName: "reportServiceImpl",
          methodName: "queryCostCenterSummaryListPage",
          queryType: this.formInline.queryType,
          startDate: this.formInline.startDate,
          endDate:this.formInline.endDate,
          monthType: this.formInline.monthType,
          limit: this.formInline.limit,
          page: this.formInline.page,
          fileName: "成本中心汇总表.xls",
        },
        "/wage",true
        );
      },
    }
  }
</script>
<style scoped>
  .downLoad,
  .del {
    font-size: 12px;
    margin-left: 20px;
    font-weight: 500;
    color: rgba(64, 158, 255, 1);
    line-height: 17px;
    cursor: pointer;
  }

  .fileName {
    padding-bottom: 10px;
    line-height: 17px;
  }

  .fileName img,
  .fileName span {
    vertical-align: middle;
  }

  .fileName span {
    height: 17px;
    line-height: 17px;
  }

  .fileName span.oneOwner {
    padding-left: 42px;
  }

  .fileName img {
    margin-right: 20px;
  }

  .fileName:nth-last-of-type(1) {
    padding-bottom: 0;
  }

  .el-row {
    text-align: right;
    margin-bottom: 10px;
  }

  .upload {
    font-size: 12px;
    margin-right: 50px;
    font-weight: 500;
    color: rgba(64, 158, 255, 1);
    line-height: 17px;
  }

  .el-form--inline>>>.el-form-item {
    margin-bottom: 0;
  }
</style>
<style>
  /*.vxe-table--body-wrapper.body--wrapper{
    overflow-x: hidden;
  }*/
  .vxe-table:not(.air-table-main) .vxe-table--footer{
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
    position: relative;
    bottom: -8px;
    border-top: 1px solid #eee;;
  }
</style>
